import styled from 'styled-components';

export const ModalStyle = styled.div``;
